import { FARM_DAY, FEED_AUTH_KEY } from '@/constants';
import { logoutMiddleware } from '@/middleware/logout';
import { navigateToLoginExpired } from '@/middleware/session-expired-navigation';

import { AxiosInstance } from './index';

// dedup: shared refresh em voo, evita N refresh para N requests 401 concorrentes
let refreshPromise: Promise<string> | null = null;

// refresh em voo (ou null). Quem chamar segura a request ate resolver e usa token novo.
export function getPendingRefresh(): Promise<string> | null {
  return refreshPromise;
}

export function getOldRefresh(): string | null {
  const authStorage = localStorage.getItem(FEED_AUTH_KEY);
  const auth = authStorage ? JSON.parse(authStorage) : null;
  return auth?.refresh ?? null;
}

export function forceLogout() {
  AxiosInstance.defaults.headers.common.Authorization = false;
  AxiosInstance.defaults.headers.common[FARM_DAY] = false;
  logoutMiddleware();
  if (typeof window !== 'undefined') {
    navigateToLoginExpired();
  }
}

// 401 de token invalido -> tenta refresh + retry. Nao trata erro de credencial no login.
export function isInvalidTokenError(status: number | undefined, message: string | undefined): boolean {
  return status === 401 && /token/i.test(message ?? '');
}

// fetchNewAuth faz a chamada de rede (axios ou fdm://); aqui só dedup + persistência
export async function runRefresh(fetchNewAuth: () => Promise<{ token: string }>): Promise<string> {
  if (refreshPromise) return refreshPromise;

  refreshPromise = (async () => {
    const data = await fetchNewAuth();
    localStorage.setItem(FEED_AUTH_KEY, JSON.stringify(data));
    AxiosInstance.defaults.headers.common.Authorization = `Bearer ${data.token}`;
    return data.token;
  })();

  try {
    return await refreshPromise;
  } finally {
    refreshPromise = null;
  }
}
